export default "__VITE_ASSET__UK4v92$e__"